import { createIcon } from '../icon'
import ShortsIcon from '../svg/ShortsIcon'

export const ShortsIconDefault = createIcon(ShortsIcon)
